import { navLinks } from '@/mocks/homeData';

export default function Footer() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-200/70">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-[1280px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-base font-heading">
                  赛
                </span>
                <span className="font-heading text-lg font-bold text-foreground-900">
                  每日大赛
                </span>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed max-w-[280px]">
                国内领先的娱乐PK投票平台，每日更新热门话题对决，千万吃瓜群众实时投票，去水靠真热度。
              </p>
            </div>

            <div>
              <div className="text-sm font-bold text-foreground-900 mb-4 font-heading">快速导航</div>
              <div className="space-y-2.5">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => handleScroll(e, link.href)}
                    className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <div className="text-sm font-bold text-foreground-900 mb-4 font-heading">PK分类</div>
              <div className="space-y-2.5">
                <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">明星PK</a>
                <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">话题对决</a>
                <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">八卦PK</a>
                <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">影视对决</a>
                <a href="#cards" onClick={(e) => handleScroll(e, '#cards')} className="block text-sm text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">音乐PK</a>
              </div>
            </div>

            <div>
              <div className="text-sm font-bold text-foreground-900 mb-4 font-heading">合作伙伴</div>
              <p className="text-sm text-foreground-500 leading-relaxed">
                每日大赛诚邀娱乐媒体、内容平台、品牌方携手合作，共同打造更有趣的娱乐互动体验。合作联系请通过上方联系方式。
              </p>
            </div>
          </div>

          <div className="pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 每日大赛官网 — 娱乐PK与每日投票，去水靠真热度
            </p>
            <div className="flex items-center gap-4">
              <a href="#faq" onClick={(e) => handleScroll(e, '#faq')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">
                常见问题
              </a>
              <a href="#contact" onClick={(e) => handleScroll(e, '#contact')} className="text-xs text-foreground-500 hover:text-primary-500 transition-colors no-underline cursor-pointer">
                联系我们
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}